module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ThinItalic-3fe433a211218ce3f70e4059c2b485dd.woff2";